<ng-container *mobxAutorun>
  <form
    *ngIf="relativeStorage.has() && relativeStorage.get() !== null"
    class="container"
    [name]="path"
    (submit)="$event.preventDefault()"
  >
    <!-- Form title -->
    <div class="form-title-container">
      <h1 class="form-title">{{ label }}</h1>
      <!-- Form actions -->
      <lf-actions-menu
        class="form-actions"
        [actions]="_formActions"
        buttonsSize="sm"
        [alignMenusRight]="true"
      >
      </lf-actions-menu>
    </div>

    <!-- Form content -->
    <ng-content></ng-content>
  </form>

  <!-- Help modal -->
  <lf-modal #helpModal class="help-modal" size="lg" *ngIf="helpMessage">
    <lf-modal-header>{{ helpActionText }}</lf-modal-header>
    <lf-modal-body [innerHTML]="helpMessage"></lf-modal-body>
  </lf-modal>

  <!-- Modal to confirm form deletion -->
  <lf-modal *ngIf="isRemovable" #removeModal class="remove-modal">
    <lf-modal-header>{{ removeActionText }}</lf-modal-header>
    <lf-modal-body>
      <p>{{ ensureRemoveText }}</p>
    </lf-modal-body>
    <lf-modal-footer>
      <button
        lf-button
        class="cancel-remove"
        [style]="'outline-secondary'"
        size="sm"
        (click)="_cancelRemove()"
      >
        {{ cancelRemoveButtonText }}
      </button>
      <button
        lf-button
        class="confirm-remove"
        [style]="'outline-danger'"
        size="sm"
        (click)="_confirmRemove()"
      >
        {{ confirmRemoveButtonText }}
      </button>
    </lf-modal-footer>
  </lf-modal>
</ng-container>
